export const TRACKING_ACTION_TYPES = {
  TRACKING_METADATA: 'trackingMetadata',
  SAR: 'sar',
  STEP: 'step',
  QUERY_PARAMS: 'queryParams',
  DEVICE: 'device',
  CUSTOM: 'custom',
  RESET: 'reset',
  SUCCESS: 'success',
  LOGIN: 'login',
} as const;

export const TRACKING_STEP_TYPES = {
  START: 'Start',
  NEXT: 'Next',
  BACK: 'Back',
  SUBMIT: 'Submit',
  RESUME: 'Resume',
  SUCCESS_PAGE: 'SuccessPage',
  LOGIN: 'Login',
} as const;

export type TrackingActionType =
  (typeof TRACKING_ACTION_TYPES)[keyof typeof TRACKING_ACTION_TYPES];
export type TrackingStepType =
  (typeof TRACKING_STEP_TYPES)[keyof typeof TRACKING_STEP_TYPES];

export const LOGIN_SESSION_STORAGE_KEY = 'asb_login_tracking';
